// Patterns
export const EQUIPMENT_NUMBER_PATTERN = '^(([a-zA-z]{4}-)((?!0+$)[0-9]{1,6})?|([0-9]{3}-)((?!0+$)[0-9]{4})?)?$';
export const NUMBER_PATTERN = '^[0-9]$';
export const LEADING_ZEROS_PATTERN = '^[0]+';
export const EQUIPMENT_INPUT_ALLOWED_PATTERN = '^[\\s\\r\\n\\t0-9a-zA-Z-]$';
